import { Environment } from './enviroment.model';

export const environment: Environment = {
    production: true,
    apiURL: 'https://login.hippodata.de/api/',
    loginInitials: '',
    loginPassword: '',
    isTestSystem: false,
    cognito: {
        authority:
            'https://cognito-idp.eu-central-1.amazonaws.com/eu-central-1_qArvNDcKj',
        clientId: '2jmj5n12uf5av6o4kbkelhmi1e',
        redirectUrl: 'https://login.hippodata.de',
        postLogoutRedirectUri: 'https://login.hippodata.de',
        scope: 'openid',
        responseType: 'code',
        hostedUiDomain: 'https://auth.longinesid.net',
    },
};
